const MARKET_PATTERN = /^[a-z][a-z0-9-]{1,15}$/;

export function resolveWidgetMarket(value?: string | null): string {
  if (value === undefined || value === null || value === '') return 'cz';
  const market = value.trim().toLowerCase();
  if (!MARKET_PATTERN.test(market)) {
    throw new Error('The Blinkit chat market is invalid.');
  }
  return market;
}
